import * as React from 'react';
import classnames from 'classnames';
import { Link, Modal } from '@grandvisionhq/common';

const UspGroupItemLink = ({ item , className , children ,  })=>{
    const [openModal, setOpenModal] = React.useState(false);
    const { popupConfig  } = item;
    const isPopupEnabled = popupConfig && popupConfig.content && popupConfig.title;
    if (item.url) {
        return /*#__PURE__*/ React.createElement(Link, {
            href: item.url,
            className: classnames(className, `${className}__link`)
        }, children);
    }
    if (isPopupEnabled) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
            className: classnames(className, `${className}__link`),
            onClick: ()=>{
                setOpenModal(true);
            }
        }, children), isPopupEnabled && openModal && /*#__PURE__*/ React.createElement(Modal, {
            children: popupConfig.content,
            className: `${className}__modal`,
            isOpen: openModal,
            showIcon: true,
            title: popupConfig.title,
            onModalClose: ()=>setOpenModal(false)
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, children);
};

export { UspGroupItemLink };
//# sourceMappingURL=UspGroupItemLink.js.map
